module.exports = __webpack_public_path__ + "img/continueShoppingThumbnail.eb0d8bcc.png";